var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOff = function SvgStarOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.465 14.434 5.706 16.41l.718-4.185a1.15 1.15 0 0 0-.33-1.018L3.051 8.243l4.203-.611a1.15 1.15 0 0 0 .866-.63L10 3.196l1.88 3.808c.167.34.49.574.865.629l4.203.61-3.041 2.965a1.15 1.15 0 0 0-.33 1.018l.717 4.185-3.759-1.976a1.15 1.15 0 0 0-1.07 0Z",
    stroke: "#666",
    strokeWidth: 1.5
  })));
};
export default SvgStarOff;